import React, { Fragment } from 'react';
import { Item, List } from 'semantic-ui-react';
import parseServerChangeLog from './parseServerLog';
import { setValue } from '../DetailsView';

const Changeset = ({ changeset }) =>
  changeset && (
    <List bulleted>
      {Object.keys(changeset).map((change, i) => (
        <List.Item key={i}>
          {change}: {setValue(changeset[change][0]) || 'null'} =>{' '}
          {setValue(changeset[change][1]) || 'null'}
        </List.Item>
      ))}
    </List>
  );

const RelationChangeset = ({ changeset }) =>
  changeset &&
  Object.keys(changeset).map(
    (change, i) =>
      changeset[change] && (
        <Fragment key={i}>
          <List.Item>
            {change}: <Changeset changeset={changeset[change]} />
          </List.Item>
          <br />
        </Fragment>
      )
  );

const InformationEdited = ({ details }) => {
  const { changeset, relationChangesets } = parseServerChangeLog(details);
  const { flights, tickets } = relationChangesets || {};
  return (
    <Item>
      <Item.Content>
        <strong>Claim details:</strong>
        <Changeset changeset={changeset} />
        <br />
        <strong>Flights:</strong>
        <RelationChangeset changeset={flights} />
        <br />
        <strong>Tickets:</strong>
        <RelationChangeset changeset={tickets} />
      </Item.Content>
    </Item>
  );
};
export default InformationEdited;



// WEBPACK FOOTER //
// ./src/component/ClaimPage/ClaimHistory/HistoryItem/ActionTypes/InformationEdited.js